export default "__VITE_ASSET__BOTxkxTE__"